var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentVisibled),expression:"currentVisibled"}]},[_vm._ssrNode("<span"+(_vm._ssrClass(null,_vm.listItemGroupClasses))+">"+_vm._ssrEscape(_vm._s(_vm.label))+"</span> "),_vm._ssrNode("<ul>","</ul>",[_vm._t("default")],2)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f2bef02","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/list/list-group.vue
// module id = 363
// module chunks = 0 1 7 10 11 18